export const urls = {
  CANCEL_URL: '/payment/cancel',
  REDIRECT_URL: '/payment/succeed',
}
